import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import Calculator from "./components/Calculator";
import TopBar from "./components/TopBar";
const theme = createTheme({
  typography: {
    fontFamily: ["Heebo", "cursive"].join(","),
    fontSize: 12,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <TopBar />
      <Calculator />
    </ThemeProvider>
  );
}

export default App;
